export const buildProvenance = { "commitHash": "b782a75eaaf97058625ec01085deb5bc20fd37de", "branchName": "refs/heads/release/2025.2", "buildDate": "2025-12-03T03:13:51.614Z", "version": "2025.2.13262" };
